export default [
    {
        // UserProfile will be rendered inside User's <router-view>
        // when /user/:id/profile is matched
        path: '/produits',
        name: 'products',
        component: () => import('../views/Product.vue'),
        meta: {
            requiresAuth: true,
            authorize: ['ROLE_ADMIN','ROLE_MANAGER'],
            layout: 'default',
            breadcrumb: 'produits',
            description: 'Gestion des produits'
        }
    }
]
